var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('toggle-plan',{attrs:{"listType":_vm.listType,"enabled":_vm.enabled,"planId":_vm.planId}}),_c('delete-plan',{attrs:{"listType":_vm.listType,"planId":_vm.planId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }